import intlTelInput from "intl-tel-input";

import idempotence from "../../idempotence";
import nodeListToArray from "../../nodeListToArray";
import ready from "../../ready";

const intlTelInputComponent = {
  init() {
    nodeListToArray(
      document.querySelectorAll("[data-js-intl-tel-input]")
    ).forEach((input) => {
      this.initItem(input);
    });
  },

  initItem(input) {
    if (idempotence.guard(input, "intl-tel-input")) return;

    // Save and remove name before init so intl-tel-input creates a new hidden
    // input rather than reusing the visible input as the "existing" one.
    const fieldName = input.getAttribute("name") || "";
    input.removeAttribute("name");

    const iti = intlTelInput(input, {
      initialCountry: "us",
      nationalMode: true,
      hiddenInput() {
        return { phone: fieldName, country: "" };
      },
      loadUtils: () => import("intl-tel-input/utils"), // eslint-disable-line import/no-unresolved
    });

    // Strip whitespace on form submit as a safety measure
    const form = input.closest("form");
    if (form) {
      form.addEventListener("submit", () => {
        const number = iti.getNumber();
        if (number) {
          iti.setNumber(number.replace(/\s/g, ""));
        }
      });
    }
  },
};

ready(() => {
  intlTelInputComponent.init();
});

export default intlTelInputComponent;
